(() => {
  'use strict';
  // Footer ship-to (audit #15 + WCAG 3.2.2): a pointer choice submits right away; keyboard users can arrow through the
  // list without leaving the page and submit with the Update button (shown while the form has focus) or Enter.
  let pointerAt = 0;
  document.addEventListener('pointerdown', (event) => { if (event.target.closest && event.target.closest('select[data-autosubmit]')) pointerAt = Date.now(); });
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (select && select.matches && select.matches('select[data-autosubmit]') && select.form && Date.now() - pointerAt < 10000) select.form.submit();
  });
  // Home only: the header sits over the hero and turns dark once the shopper scrolls (same 45px threshold as byrdgang.com).
  // From 1024px the header is solid and the tab row sits under it (audit #9), so this only matters on smaller screens.
  const header = document.querySelector('#header.bg-overlay-header');
  if (!header) return;
  const update = () => header.classList.toggle('scrolled', window.scrollY > 45);
  window.addEventListener('scroll', update, { passive: true });
  update();
})();
